<template>
  <div class="panel-body">
    <div>
      <h4 class="promo-section-title">広告の運用</h4>
      <div class="promo-opt-grid">
        <div
          class="promo-opt-card promo-opt-card--apply"
          :class="{ sel: promotionRequest.promotionFlg === '1' }"
        >
          <div class="promo-opt-header">
            <span class="promo-opt-title">申し込む</span>
            <span :class="{ 'promo-opt-badge': promotionRequest.promotionFlg === '0', 'promo-current-badge': promotionRequest.promotionFlg === '1' }">
              {{ promotionRequest.promotionFlg === '0' ? 'おすすめ' : '現在の設定' }}
            </span>
          </div>
          <p class="promo-opt-desc">商品の露出を増やし、販売機会を広げます<br>売れた場合のみ広告費が発生します</p>
          <button
            v-if="promotionRequest.promotionFlg === '0'"
            class="promo-apply-btn"
            @click.stop="requestChange('1')"
          >広告運用を申し込む</button>
        </div>
        <div
          class="promo-opt-card"
          :class="{ sel: promotionRequest.promotionFlg === '0' }"
        >
          <div class="promo-opt-header">
            <span class="promo-opt-title">申し込まない</span>
            <span v-if="promotionRequest.promotionFlg === '0'" class="promo-current-badge promo-current-badge--opt-not-applied">現在の設定</span>
          </div>
          <p class="promo-opt-desc">広告運用は行われません</p>
          <button
            v-if="promotionRequest.promotionFlg === '1'"
            class="btn btn-normal"
            @click.stop="requestChange('0')"
          >広告運用を停止する</button>
        </div>
      </div>

      <div>
        <fieldset class="border">
          <legend class="border" v-if="promotion"><b>{{ promotion.title }}</b></legend>
          <div class="text-left">
            <div v-if="promotion" v-html="replaceHTMLSellerInfo(promotion.content)"></div>
          </div>
        </fieldset>
      </div>
    </div>

    <modal-confirm
      v-if="showConfirmModal"
      :message="confirmMessage"
      @confirm="confirmChange"
      @close="cancelChange"
    />

    <modal-alert
      v-if="showSuccessModal && promotionRequest.promotionFlg === '1'"
      :message="successOnMessage"
      :closeButtonText="'広告商品を登録する'"
      @close="goToRegistration"
    />

    <modal-alert
      v-if="showSuccessModal && promotionRequest.promotionFlg === '0'"
      :message="successOffMessage"
      @close="closeSuccessModal"
    />
  </div>
</template>

<script>
import PromotionService from '@/services/promotionservice'
import SettingService from '@/services/settingservice'
import store from '@/store'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'
import { replaceHTMLSellerInfo } from '@/common/utility'
import ModalConfirm from '@/components/ModalConfirm'
import ModalAlert from '@/components/ModalAlert'

export default {
  components: {
    ModalConfirm,
    ModalAlert
  },
  props: {
    currentTab: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      err: null,
      promotion: null,
      loader: null,
      promotionRequest: {
        promotionFlg: '0'
      },
      pendingFlg: null,
      showConfirmModal: false,
      confirmMessage: '広告運用の設定を変更しますか？',
      showSuccessModal: false
    }
  },

  created () {
    this.getUserInfo()
    this.getPromotionDiscription()
  },

  computed: {
    successOnMessage () {
      return `
        <span class="font-bold">広告運用の設定を変更しました</span>
        <br>
        <span class="text-danger">広告運用する商品を登録しましょう！</span>
        <br>
        商品を登録すると、広告運用を開始できます
      `
    },
    successOffMessage () {
      return '広告運用の設定を変更しました'
    }
  },

  methods: {
    replaceHTMLSellerInfo,
    async getUserInfo () {
      try {
        const response = await SettingService.getSellerInformation()
        if (Object.keys(response).length !== 0) {
          this.promotionRequest.promotionFlg = response.seller.promotionFlg
        }
      } catch (err) {
        this.err = err
      }
    },

    async getPromotionDiscription () {
      let self = this
      PromotionService.getPromotionDiscription()
        .then((response) => {
          self.promotion = response['promotion'][0]
        })
        .catch((error) => {
          self.err = error
        })
        .finally(() => {
          if (this.$route.params.tab === 'top') {
            this.$events.fire('done')
          }
        })
    },

    requestChange (newFlg) {
      if (this.promotionRequest.promotionFlg === newFlg) return
      this.pendingFlg = newFlg
      this.showConfirmModal = true
    },

    cancelChange () {
      $('#confirm-alert').modal('hide')
      this.showConfirmModal = false
    },

    async confirmChange () {
      $('#confirm-alert').modal('hide')
      this.showConfirmModal = false
      await this.updatePromotionRequest()
    },

    closeSuccessModal () {
      $('#myModal').modal('hide')
      this.showSuccessModal = false
    },

    goToRegistration () {
      $('#myModal').modal('hide')
      this.showSuccessModal = false
      this.$router.push('/promotion/promotion-request')
    },

    async updatePromotionRequest () {
      let self = this
      let user = self.$store.getters.getUser
      let logParams = {
        name: eventCode.promotion.top_tab.click_update_button,
        properties: {
          oldUserPromotionFlg: user.promotionFlg,
          newUserPromotionFlg: self.pendingFlg
        }
      }
      EventService.postTrackLog(logParams)

      user.promotionFlg = self.pendingFlg
      self.loader = self.$loading.show()
      const payload = {
        record: {
          promotionFlg: user.promotionFlg
        }
      }
      await PromotionService.updatePromotion(payload)
        .then(() => {
          store.commit('setUser', user)
          self.$emit('checkData', true)
          self.promotionRequest.promotionFlg = self.pendingFlg
          self.pendingFlg = null
          self.showSuccessModal = true
        })
        .catch((err) => {
          store.commit('toggleModal', { show: true, message: err })
          self.err = err
          self.pendingFlg = null
        })
        .finally(() => {
          self.loader && self.loader.hide()
        })
    }
  },

  mounted () {
    if (this.currentTab && this.currentTab === 'top') {
      let logParams = {
        name: eventCode.promotion.top_tab.show,
        properties: {}
      }
      EventService.postTrackLog(logParams)
    }
  },

  beforeDestroy () {
    this.loader && this.loader.hide()
  }
}
</script>

<style scoped>
.promo-section-title {
  font-size: 15px;
  font-weight: bold;
  margin: 0 0 14px;
}
.promo-opt-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  max-width: 600px;
  margin-bottom: 20px;
}
.promo-opt-card {
  background: #fff;
  border: 2px solid #dde1eb;
  border-radius: 12px;
  padding: 18px 20px 20px;
  cursor: pointer;
  transition: border-color 0.15s, box-shadow 0.15s;
  user-select: none;
  display: flex;
  flex-direction: column;
}
.promo-opt-card:hover {
  border-color: #aab8cc;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.07);
}
.promo-opt-card.sel {
  border-color: #aab8cc;
}

/* 申し込む card */
.promo-opt-card--apply {
  background: #fffbef;
  border-color: #f5a73b;
}
.promo-opt-card--apply:hover {
  border-color: #e09030;
  box-shadow: 0 2px 12px rgba(245, 167, 59, 0.18);
}
.promo-opt-card--apply.sel {
  border-color: #e09030;
  background: #fff5d6;
}

.promo-opt-badge {
  display: inline-block;
  font-size: 11px;
  color: #000;
  background-color: yellow;
  border-radius: 20px;
  padding: 1px 9px;
  white-space: nowrap;
  line-height: 1.6;
}
.promo-opt-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
}
.promo-opt-title {
  font-size: 18px;
  font-weight: 700;
  color: #333;
}
.promo-current-badge {
  display: inline-block;
  font-size: 11px;
  color: #fff;
  background-color: #008cc6;
  border-radius: 20px;
  padding: 1px 9px;
  white-space: nowrap;
  line-height: 1.6;
}
.promo-current-badge--opt-not-applied {
  background-color: #ccc;
  color: #000;
}
.promo-opt-desc {
  font-size: 13px;
  color: #5a6275;
  line-height: 1.7;
  margin: 0 0 auto;
}
.promo-apply-btn {
  display: block;
  width: 100%;
  margin-top: 18px;
  padding: 11px 0;
  background: #f5a73b;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.15s;
}
.promo-apply-btn:hover:not(:disabled) {
  background: #e09030;
}
.promo-apply-btn:disabled {
  background: #f5c98a;
  cursor: not-allowed;
}
@media (max-width: 520px) {
  .promo-opt-grid { grid-template-columns: 1fr; }
}
</style>



// WEBPACK FOOTER //
// src/view/promotion/Top.vue